"use client"

import { useEffect, useRef } from "react"
import { MapPin } from "lucide-react"
import { HeadingText } from "@/components/atoms/HeadingText/heading-text"
import Text from "@/components/atoms/Text/text"
import { Tag } from "@/components/atoms/Tag"
import { ViewCounter } from "@/components/molecules/ViewCounter"

type PropertyHeaderProps = {
  location: string
  title: string
  propertyFor: string
  price: string
  priceLabel: string
  propertyId?: string
  editorView?: boolean
  initialViewCount?: number
}

export const PropetyHeader = ({
  location,
  title,
  propertyFor,
  price,
  priceLabel,
  propertyId,
  editorView = false,
  initialViewCount = 0,
}: PropertyHeaderProps) => {
  return (
    <div className="grid px-5 md:grid-cols-2 lg:px-0">
      <div className="flex flex-col justify-start">
        <div className="flex items-center justify-between">
            <HeadingText className="capitalize" level={2}>{title}</HeadingText>
        </div>
        <div className="flex place-items-center justify-start py-5">
          <Tag bgColor={"bg-black"} textColor={"text-white"} label={propertyFor} />
          <div className="ml-4 flex flex-1 place-items-center text-gray-500">
            <MapPin className="pr-2" size={30} />
            <Text className="text-gray-500">{location}</Text>
          </div>
        </div>
      </div>
      <div className="flex lg:justify-end">
        <HeadingText level={2}>{`${priceLabel}: $${price}`}</HeadingText>
      </div>
    </div>
  )
}
